import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import {
	MAT_DIALOG_DATA,
	MatDialogActions,
	MatDialogClose,
	MatDialogContent,
	MatDialogRef,
	MatDialogTitle,
} from '@angular/material/dialog';
import { InfoboxService } from '@/common/infobox/infobox.service';
import { filter } from 'rxjs';
import { MatButton } from '@angular/material/button';
import { MatError, MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { TransportTemplateApiService } from '@/new-transport/transport-template/_api/transport-template.api.service';
import { Transport } from '@/new-transport/_models/transport.model';

interface TemplateCopyData {
	name: string;
	transport: Transport;
}

@Component({
	selector: 'app-template-duplicate',
	standalone: true,
	imports: [
		FormsModule,
		MatButton,
		MatDialogActions,
		MatDialogClose,
		MatDialogContent,
		MatDialogTitle,
		MatFormField,
		MatInput,
		ReactiveFormsModule,
		MatError,
	],
	templateUrl: './template-duplicate.component.html',
	styleUrl: './template-duplicate.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TemplateDuplicateComponent implements OnInit {
	readonly transportTemplateForm: FormGroup = new FormGroup({
		name: new FormControl('', [Validators.required]),
	});

	private readonly data: TemplateCopyData = inject(MAT_DIALOG_DATA);
	private readonly templateApiService = inject(TransportTemplateApiService);
	private readonly dialogRef = inject(MatDialogRef<TemplateDuplicateComponent>);
	private readonly infobox = inject(InfoboxService);

	ngOnInit(): void {
		if (this.data) {
			this.transportTemplateForm.patchValue(this.data);
		}
	}

	save(): void {
		const transportTemplateId = this.data.transport.id;

		const transportTemplateName: Pick<TemplateCopyData, 'name'> = {
			name: this.transportTemplateForm.controls.name.value ?? this.data.transport.name,
		};

		this.createDuplicateTemplate(transportTemplateId, transportTemplateName);
	}

	private createDuplicateTemplate(
		transportTemplateId: number,
		transportTemplateName: Pick<TemplateCopyData, 'name'>,
	): void {
		this.templateApiService
			.createTransportTemplateDuplicate(transportTemplateId, transportTemplateName)
			.pipe(filter((result) => !!result))
			.subscribe((duplicateTransportTemplate) => this.dialogRef.close(duplicateTransportTemplate.id));
	}
}
